import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ExternalLink, FileText } from "lucide-react";

export default function FaqView({ kind, title }) {
  const [info, setInfo] = useState({ url: null, updated_at: null });

  useEffect(() => {
    api.get(`/faq/${kind}`).then((r) => setInfo(r.data || {}));
  }, [kind]);

  const updated = info.updated_at
    ? new Date(info.updated_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })
    : "";

  return (
    <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
      <header className="mb-8">
        <div className="text-xs font-mono uppercase tracking-widest text-amber-800">Documents</div>
        <h1 className="mt-1 font-serif text-4xl font-semibold text-stone-900 sm:text-5xl">{title}</h1>
        <p className="mt-2 text-stone-600">
          View the latest frequently-asked-questions document maintained by the Managing Agent.
        </p>
      </header>

      {info.url ? (
        <div className="rounded-3xl border border-stone-200 bg-white p-6 shadow-sm sm:p-8" data-testid={`faq-${kind}-card`}>
          <div className="flex items-start gap-4">
            <div className="rounded-2xl bg-amber-50 p-4 ring-1 ring-amber-100">
              <FileText className="h-7 w-7 text-amber-800" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="font-serif text-xl font-semibold text-stone-900">{title}</div>
              {updated && <div className="text-sm text-stone-500">Updated {updated}</div>}
              <p className="mt-3 text-sm text-stone-600">
                The document is hosted on Google Drive — tap below to open it in a new tab (works on mobile and desktop).
              </p>
              <a
                href={info.url}
                target="_blank"
                rel="noreferrer"
                data-testid={`faq-${kind}-open-link`}
                className="mt-5 inline-flex items-center gap-2 rounded-xl bg-[#78350f] px-5 py-3 font-medium text-white shadow-sm transition hover:bg-[#602a0c]"
              >
                <ExternalLink className="h-4 w-4" />
                Open FAQs on Google Drive
              </a>
            </div>
          </div>
        </div>
      ) : (
        <div className="rounded-3xl border border-dashed border-stone-300 bg-white p-10 text-center text-stone-600">
          No link has been added yet. Please check back soon.
        </div>
      )}
    </div>
  );
}
